/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Safe_2_BodyInputs */

const da_forside_safe_2_body = /** @type {(inputs: Forside_Safe_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasser har kun nummer og alias, og navne dækkes på besvarelserne før upload.`)
};

/** @type {(inputs: Forside_Safe_2_BodyInputs) => LocalizedString} */
const en_forside_safe_2_body = da_forside_safe_2_body;

/**

* @param {Forside_Safe_2_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_safe_2_body = /** @type {((inputs?: Forside_Safe_2_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Safe_2_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_safe_2_body(inputs)
	return /** @type {LocalizedString} */ ("Klasser har kun nummer og alias, og navne dækkes på besvarelserne før upload.")
});